import styled from '@emotion/styled';
import { Box, BoxProps, MantineProvider, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { BrowserRouter, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import { GlobalContextProvider } from './context/global-context';
import { useFetchSessionToken } from './hooks';
import routes from './routes';
import { CustomFonts } from './utils/styles/CustomFonts';
import { leftSideStyle } from './utils/styles/GlobalStyle';
import { GlobalTheme } from './utils/styles/GlobalTheme';
import theme from './utils/styles/theme';
import Landing from './pages/Landing';
import { useNetwork } from '@mantine/hooks';
import { NoWiFi } from './assets';
import { MultipleNotification } from './components/MultipleNotification';
import { useEffect } from 'react';
import { isProduction, openImageDB, saveImages } from './config/Helper';
import useOnlineStatus from './hooks/useOnlineStatus';
import { CartContextProvider } from './context/cart-context.tsx';

const WebWrapper = styled(Box)<BoxProps>`
  .Toastify__toast-container:has(.toast-online) {
    z-index: 10000;
  }
  &.landing-page {
    height: 100svh;
    .landing-wrapper {
      width: 100%;
    }

    .landing-section {
      height: calc(100svh - 82px);
      position: relative;
      .logo-section {
        position: absolute;
        top: 40px;
        width: 100%;
        > * {
          margin: auto;
          display: block;
        }
      }
      .prepare-order-section {
        position: absolute;
        bottom: 0px;
        .mantine-Image-image {
          width: 25% !important;
          margin: auto;

          @media (max-width: 992px) {
            width: 30% !important;
          }

          @media (max-width: 768px) {
            width: 50% !important;
          }
          @media (max-width: 480px) {
            width: 60% !important;
          }
        }
      }

      .tag-line {
        .mantine-Image-image {
          width: 60% !important;
          height: 100px !important;
          margin: auto;
        }
      }

      @media (max-width: 480px) {
        height: calc(100svh - 100px);
      }
    }
  }
`;

const saveOfflineImages = async () => {
  await openImageDB();

  await saveImages([
    { key: 'logo', imageUrl: '/icons/clamor-black-white.svg' },
    { key: 'logotext', imageUrl: '/icons/logotext.svg' },
    { key: 'no-wifi', imageUrl: '/icons/no-wifi.svg' },
  ]);
};

function App() {
  const { classes: leftsideClasses } = leftSideStyle();
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const { isLoading } = useFetchSessionToken();
  const networkStatus = useOnlineStatus();

  useEffect(() => {
    window.onpopstate = function () {
      if (!networkStatus?.online) {
        window.history.go(1);
      }
    };

    saveOfflineImages();
  }, [networkStatus?.online]);

  // To manually of all the console

  // useEffect(() => {
  //   if (isProduction()) {
  //     console.log = () => {};
  //     console.debug = () => {};
  //     console.info = () => {};
  //     console.warn = () => {};
  //     console.error = () => {};
  //   }
  // }, []);

  return (
    <ErrorBoundary>
      <WebWrapper className={'landing-page'} pos='relative'>
        <ToastContainer className={mobile ? leftsideClasses.toastContainer : ''} />
        <BrowserRouter>
          <GlobalContextProvider>
            <CartContextProvider>
              <MantineProvider theme={theme}>
                <GlobalTheme />
                <CustomFonts />
                <Header />

                {networkStatus.online ? (
                  <>{isLoading ? <Landing /> : <Routes>{routes}</Routes>}</>
                ) : (
                  <Box
                    pos='fixed'
                    top={0}
                    left={0}
                    w='100vw'
                    h='100vh'
                    bg='rgba(0, 0, 0, 0.45)'
                    style={{ zIndex: 9999 }}>
                    <MultipleNotification
                      mainText={'You aren’t accepting new order'}
                      secondText={'Please check your Internet connection'}
                      icon={NoWiFi}
                      textColor={'deepRed'}
                    />
                  </Box>
                )}
                {/* <Landing /> */}
                {/* {isLoading ? (
              <Landing />
            ) : (
              <>
                
              </>
            )} */}
              </MantineProvider>
            </CartContextProvider>
          </GlobalContextProvider>
        </BrowserRouter>
      </WebWrapper>
    </ErrorBoundary>
  );
}

export default App;
